<template
  ><div>
    <v-autocomplete
      class="my-2"
      hide-details
      label="Manageengine User"
      :placeholder="loading == true ? 'loading...' : 'Start typing...'"
      :items="filteredUsers"
      :search-input.sync="search"
      item-text="displayText"
      :loading="loading"
      return-object
      v-model="model"
      :rules="[rules.required]"
      @input="onUserSelected"
      clearable
    >
      <template v-slot:item="{ item }">
        <v-list-tile-content>
          <v-list-tile-title>{{ item.name }}</v-list-tile-title>
          <v-list-tile-sub-title
            >{{ item.emailId }}
            {{ item.extension ? item.extension : "" }}
            {{ item.phone ? item.phone : "" }}
            {{ item.phoneMapped ? item.phoneMapped : "" }}
            {{
              item.portalUsername ? item.portalUsername : ""
            }}</v-list-tile-sub-title
          >
        </v-list-tile-content>
      </template>
    </v-autocomplete>
  </div>
</template>
<script>
export default {
  props: {
    active: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    active: {
      immediate: true,
      handler(val) {
        if (val && this.manageengineUsers.length === 0) {
          this.loadManageEngineUsers();
        }
        if (!val) {
          this.reset();
        }
      },
    },
  },
  computed: {
    usersWithDisplay() {
      return this.manageengineUsers.map((user) => ({
        ...user,
        displayText:
          `${user.name || ""} ${user.emailId || ""} ${user.extension ||
            ""} ${user.phone || ""} ${user.phoneMapped ||
            ""} ${user.portalUsername || ""}`.trim() || "No Name",
      }));
    },
    filteredUsers() {
      if (!this.search) return this.usersWithDisplay;

      const term = this.search.toLowerCase().trim();

      return this.usersWithDisplay.filter((user) => {
        const email = (user.emailId || "").toLowerCase();
        const name = (user.name || "").toLowerCase();
        const display = (user.displayText || "").toLowerCase();

        return (
          email.includes(term) || name.includes(term) || display.includes(term)
        );
      });
    },
  },
  data: () => ({
    loading: false,
    search: "",
    manageengineUsers: [],
    model: null,
    rules: {
      required: (value) => !!value || "Required.",
    },
  }),
  methods: {
    async loadManageEngineUsers() {
      this.loading = true;
      const response = await this.$http.get(`/odata/ManageEngineUsers`);
      this.manageengineUsers = response.value;
      this.loading = false;
    },
    onUserSelected(val) {
      this.$emit("manageEngineUsers", this.manageengineUsers);
      this.$emit("selectedUser", val);
    },
    reset() {
      this.model = null;
    },
  },
};
</script>
